<div class="menu-propos-nous">
  <div class="menu-main">
    <div class="menu-main-item">
      <a [routerLink]="['/le-concept-the-door-man.html']" class="lien-txt">
        <div class="menu-main-item-icon">
          <img width="38" height="38" src="assets/svg/qui-sommes-nous.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/le-concept-the-door-man.html']" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Qui sommes-nous ?</span>
          <span class="normal-sm">Notre histoire, notre approche et nos valeurs</span>
        </div>
      </a>
    </div>
    <div class="menu-main-item">
      <a [routerLink]="['/contact']" fragment="Partenariat" class="lien-txt">
        <div class="menu-main-item-icon">
          <img width="40" height="30" src="assets/svg/partenaires.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/contact']" fragment="Partenariat" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">Devenir partenaire</span>
          <span class="normal-sm">Rejoignez notre communauté d'apporteurs d'affaires en immobilier</span>
        </div>
      </a>
    </div>
    <div class="menu-main-item">
      <a [routerLink]="['/accueil']" fragment="ancre-conseils" class="lien-txt">
        <div class="menu-main-item-icon">
          <img width="40" height="34" src="assets/svg/actu-reseau.svg" alt="">
        </div>
      </a>
      <a [routerLink]="['/accueil']" fragment="ancre-conseils" class="lien-txt">
        <div class="menu-main-item-text">
          <span class="bold-base">L’actualité du réseau</span>
          <span class="normal-sm">Toutes les dernières infos sur notre réseau de Conseillers en immobilier</span>
        </div>
      </a>
    </div>
  </div>

  <div class="menu-secondary">
    <div class="bold-xl">Besoin de THE DOOR MAN ?</div>
    <div class="semibold-sm gray700">Vous avez une question ?<br>Contactez-nous et bénéficiez d'une réponse rapide de
      nos équipes.
    </div>
    <button [routerLink]="['/contact']" fragment="Nous-contacter" type="button" class="btn btn-gold external-link">
      Nous contacter</button>
  </div>
</div>
